<!-- left sidebar start -->
<div id="divForAdmin" class="sidenav">
    <a href="javascript:;" id="menucollo" class="menuCollapser" (click)="toggleClass()">
        <span id="SideNavCollapser" class="fa fa-bars"></span>
        <p id="menuparContainer">
            <span class="menuClass" i18n="@@Menu">Menu</span>
        </p>
    </a>
    <div id="sideNavContent">
      <div id="menuContent">
        <a routerLink='/dashboard' id="Dashboard" class="menuclass" dataName="Dashboard"
           routerLinkActive="activeMenu">
          <i class="nav-home"></i>
          <span i18n="@@Dashboard">Dashboard</span>
        </a>

        <a routerLink='/prospect' id="Prospects" class="menuclass" dataName="Prospects"
           routerLinkActive="activeMenu">
          <i class="nav-prospect"></i>
          <span i18n="@@Prospects">Prospects</span>
        </a>

        <a routerLink='/customer' id="Customer" class="menuclass" dataName="Customers"
           routerLinkActive="activeMenu">
          <i class="nav-customer"></i>
          <span i18n="@@Customer">Customers</span>
        </a>

        <a routerLink='/units' id="Units" class="menuclass" dataName="Units"
           routerLinkActive="activeMenu">
          <i class="nav-units"></i>
          <span i18n="@@Units">Units</span>
        </a>

        <ng-container *ngIf="!isCallcenterUser">
          <a routerLink='/facimer' id="Merchandise" class="menuclass" dataName="Merchandise"
             routerLinkActive="activeMenu">
            <i class="nav-merchandise"></i>
            <span i18n="@@Merchandise">Merchandise</span>
          </a>
        </ng-container>

        <a routerLink='/layouts' id="Layouts" class="menuclass" dataName="Layouts" routerLinkActive="activeMenu">
          <i class="nav-layout"></i>
          <span i18n="@@Layouts">Layouts</span>
        </a>

        <a routerLink='/report' class="menuclass" id="Reports" dataName="Reports" routerLinkActive="activeMenu" [routerLinkActiveOptions]="{ exact: true }">
          <i class="nav-report"></i>
          <span i18n="@@Reports">Reports</span>
        </a>

        <a routerLink='/facilityAdmin' class="menuclass" id="Admin" dataName="Batch Process"
           routerLinkActive="activeMenu">
          <i class="nav-settings"></i>
          <span i18n="@@Admin">Batch Admin</span>
        </a>

        <a routerLink='/openClose' class="menuclass" id="Open/Close" dataName="Open/Close Store"
           routerLinkActive="activeMenu">
          <i class="nav-dayend"></i>
          <span i18n="@@openClose">Open / Close Store</span>
        </a>

        <a class="menuclass" id="open-app-btn" dataName="Ringcentral-Widget"
           *ngIf="this.phoneSystem && this.phoneSystem == 466" (click)="openRingCentralWidget()">
          <i class="nav-ringcentral"></i>
          <span>Ringcentral Widget</span>
        </a>
         <!-- <a *ngIf="IsSSMAIAgent" target="_blank" routerLinkActive="disabled"  routerLink='/report/AI'  routerLinkActive="activeMenu" class="menuclass" id="open-app-btn" dataName="SSM AI Agent">
          <i class="nav-AIAgent"></i>
          <span>SSM AI Agent</span>
        </a> -->
        <a *ngIf="IsSSMAIAgent"
   target="_blank"
   class="menuclass"
   id="SSMAIAgent"
   dataName="SSM AI Agent"
   (click)="openAIAgent()">
    <i class="nav-AIAgent" id="NavAIAgent"></i>
    <span>SSM AI Agent</span>
    </a>
      </div>
    </div>
    <div class="lft_fade"></div>
     <div id="termsAIDialog" class="save-as-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">SSM AI Agent Terms of Use</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closeTermsDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            
<div class="ai-contentText">
    <p>
        The SSM AI Agent uses artificial intelligence to provide information, recommendations, and other assistance. AI-generated responses may be inaccurate, incomplete, or outdated and should be independently reviewed before being relied upon.<br/>
       <br/> By using the SSM AI Agent, you acknowledge and agree that:
    </p><br/><br/>
    <ul style="line-height: 1.8;">
        <li>You are responsible for reviewing and validating AI-generated content before making business, financial, legal, compliance, operational, or other decisions.</li>
        <li>The SSM AI Agent is provided as a productivity tool and does not constitute legal, financial, tax, compliance, or professional advice.</li>
        <li>Your interactions with the SSM AI Agent may be logged and reviewed by SSM for security, support, quality assurance, and product improvement purposes.</li>
        <li>SSM will not sell, share, or disclose your data, prompts, conversations, or business information to third parties except as required by law or as necessary to provide and support the SSM AI Agent and related services.</li>
        <li>You will not use the SSM AI Agent for unlawful, harmful, or unauthorized activities.</li>
        <li>SSM makes no warranties regarding the accuracy, completeness, or suitability of AI-generated content and is not liable for decisions, actions, or outcomes resulting from its use.</li>
    </ul>

    <div style="
        margin-top: 20px;
        padding: 12px 16px;
        background-color: #EFF6FF;
        border-left: 4px solid #2563EB;
        border-radius: 4px;">
        <label *ngIf="!IsAIAgentTncAgreed" id='CheckboxActive' class="pure-material-checkbox mb-0">
           <input type="checkbox" tabindex="2" class="pure-material-checkbox"
           [(ngModel)]="isAgreeChecked" aria-label="I agree to the SSM AI Agent Terms of Use">
           <span></span>
        </label>
        <strong *ngIf="!IsAIAgentTncAgreed">  By selecting "I Agree," you accept these Terms and understand that you are responsible for your use of the SSM AI Agent and any reliance on its outputs.</strong>
        <strong *ngIf="IsAIAgentTncAgreed">You have accepted these Terms and acknowledged your responsibility for using the SSM AI Agent and any reliance on its outputs.</strong>
    </div> 

</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
       <button
    *ngIf="!IsAIAgentTncAgreed"
    type="button"
    class="btn btn-outline-primary me-3"
    [disabled]="!isAgreeChecked"
    data-bs-dismiss="modal"
    (click)="updateAIAgreedTerms(true)">
    I Agree
</button>
<!-- 
<button *ngIf="IsAIAgentTncAgreed"
    type="button"
    class="btn btn-outline-primary me-3"
    data-bs-dismiss="modal"
    (click)="updateAIAgreedTerms(false)">
    Disagreed
</button> -->
<button *ngIf="IsAIAgentTncAgreed"
    type="button"
    class="btn btn-outline-primary me-3"
    data-bs-dismiss="modal"
    (click)="closeTermsDialog()">
    Back
</button>
      </div>
    </div>
  </div>
</div>
<!-- left sidebar end -->
